import { render, staticRenderFns } from "./DocumentCalculatorNotes.vue?vue&type=template&id=0413cc99&scoped=true"
import script from "./DocumentCalculatorNotes.vue?vue&type=script&lang=js"
export * from "./DocumentCalculatorNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0413cc99",
  null
  
)

export default component.exports